import React, { Component } from 'react'
import Footer from '../components/Footer'
import Mainmenu from '../components/Mainmenu'
import Navbar from '../components/Navbar'

import EmailContent from './EmailContent'

export default class Email extends Component {

    render() {
        
        let id = this.props.match.params.id;
        return (
            <div class="wrapper">
                <Navbar />
                <Mainmenu />
                <EmailContent  id={id} />
                <Footer />

            </div>


        )
    }
}
